import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setLastFileHandle } from "../../../../Redux/slice/canvasSlice";
import { handleSaveAs } from "../../../../../src/Utils/saveUtils";

const SaveAsDialog = ({ open, setOpen }) => {
  const [format, setFormat] = useState("png");
  const [dpi, setDpi] = useState(300);
  const dispatch = useDispatch();

  const canvas = useSelector((state) => state.canvas.activeCanvas);

  const handleClose = () => setOpen(false);

  const handleSaveClick = async () => {
    console.log("handleSaveClick");
    if (!canvas) return;

    await handleSaveAs(canvas, format, dpi, (fh) =>
      dispatch(setLastFileHandle(fh))
    );

    handleClose(); // close dialog after saving
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>Save As</DialogTitle>
      <DialogContent>
        {/* Format dropdown */}
        <FormControl fullWidth margin="dense">
          <InputLabel>Format</InputLabel>
          <Select
            value={format}
            onChange={(e) => setFormat(e.target.value)}
          >
            <MenuItem value="png">PNG</MenuItem>
            <MenuItem value="jpeg">JPEG</MenuItem>
            <MenuItem value="svg">SVG</MenuItem>
            <MenuItem value="pdf">PDF</MenuItem>
            <MenuItem value="tiff">TIFF</MenuItem>
            <MenuItem value="bmp">Bitmap</MenuItem>
          </Select>
        </FormControl>

        {/* DPI input */}
        <TextField
          label="DPI"
          type="number"
          fullWidth
          margin="dense"
          value={dpi}
          onChange={(e) => setDpi(Number(e.target.value))}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSaveClick} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveAsDialog;
